import CommonBulkUpload from "@components/BulkUpload";
import { getValue } from "@utils/lodash";
import MoreSubheaderSvgComponent from "../../assets/svg-components/sub-header/more";
import React, { useState } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

function BulkDownloadDropdown(props: any) {
  const { dropdownOptions, url, type } = props;

  const handleDownload = (value: string) => {
    switch (value) {
      case "ENTITY_MAPPING":
      case "IC_ENTITY_MAPPING":
        return props.handleDownloadSelfComplianceReport();

      default:
        return null;
    }
  };
  return (
    <div>
      <UncontrolledDropdown>
        <DropdownToggle className="icons-btn">
          {/* <div className="add-filter-wrapper__filter-container">
            <div className="cursor-pointer">
              <img
                src="/images/more_vertical.svg"
                className="img-fluid add-filter-wrapper__upload-image"
              />
              <p className="add-filter-wrapper__filter-title">MORE</p>
            </div>
          </div> */}
          <MoreSubheaderSvgComponent />
        </DropdownToggle>
        <DropdownMenu>
          {getValue(dropdownOptions, `length`, 0) > 0 &&
            dropdownOptions.map((item: object) => {
              return (
                <DropdownItem
                  onClick={() => {
                    handleDownload(getValue(item, `value`, ""));
                  }}
                >
                  Download {getValue(item, `label`, "")}
                </DropdownItem>
              );
            })}
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );
}

export default BulkDownloadDropdown;
